<div class="container py-4">

  <!-- Language selector -->
  @if (languages.length > 0) {
  <div class="d-flex align-items-center justify-content-center gap-2 mb-4 flex-wrap">
    <div class="form-check form-switch mb-0 me-1">
      <input class="form-check-input" type="checkbox" role="switch" id="filterMyLanguages"
        [(ngModel)]="filterMyLanguages" (change)="onLanguageFilterChange()" />
      <label class="form-check-label small" for="filterMyLanguages">My languages</label>
    </div>
    <span [appTooltip]="filterMyLanguages ? 'Uncheck My languages to edit' : ''">
      <select class="form-select form-select-sm" style="width: auto" [(ngModel)]="selectedLanguageUuid" (change)="onLanguageChange()" [disabled]="filterMyLanguages">
        <option value="" disabled>From language</option>
        @for (lang of languages; track lang.uuid) {
        <option [value]="lang.uuid" [disabled]="lang.uuid === selectedLanguageToUuid">
          {{ flags[lang.name] }} {{ lang.name }}
        </option>
        }
      </select>
    </span>
    <i class="bi bi-arrow-right text-muted"></i>
    <span [appTooltip]="filterMyLanguages ? 'Uncheck My languages to edit' : ''">
      <select class="form-select form-select-sm" style="width: auto" [(ngModel)]="selectedLanguageToUuid" (change)="onLanguageChange()" [disabled]="filterMyLanguages">
        <option value="" disabled>To language</option>
        @for (lang of languages; track lang.uuid) {
        <option [value]="lang.uuid" [disabled]="lang.uuid === selectedLanguageUuid">
          {{ flags[lang.name] }} {{ lang.name }}
        </option>
        }
      </select>
    </span>
  </div>
  }

  <!-- Loading -->
  @if (state === 'loading') {
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="mt-3 text-muted">Loading flashcards...</p>
  </div>
  }

  <!-- Error loading settings -->
  @if (state === 'error') {
  <div class="row justify-content-center">
    <div class="col-md-6 text-center py-5">
      <i class="bi bi-exclamation-triangle fs-1 text-danger"></i>
      <h4 class="mt-3">Something went wrong</h4>
      <p class="text-danger">{{ error }}</p>
      <button class="btn btn-outline-primary mt-2" (click)="retry()">Try Again</button>
    </div>
  </div>
  }

  <!-- No language settings -->
  @if (state === 'no-languages') {
  <div class="row justify-content-center">
    <div class="col-md-6 text-center py-5">
      <i class="bi bi-translate fs-1 text-muted"></i>
      <h4 class="mt-3">Select your languages</h4>
      <p class="text-muted">Choose the from and to languages above to start practicing.</p>
    </div>
  </div>
  }

  <!-- No words available -->
  @if (state === 'no-words') {
  <div class="row justify-content-center">
    <div class="col-md-6 text-center py-5">
      <i class="bi bi-journal-x fs-1 text-muted"></i>
      <h4 class="mt-3">No words to review</h4>
      <p class="text-muted">Add some words to your vocabulary to start practicing.</p>
      @if (error) {
      <p class="text-danger small">{{ error }}</p>
      }
      <a routerLink="/word/new-word" class="btn btn-primary mt-2">Add Words</a>
    </div>
  </div>
  }

  <!-- Active session -->
  @if (state === 'sentence' || state === 'translation') {
  <div class="row justify-content-center">
    <div class="col-md-7 col-lg-6">

      <!-- Progress -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted small">Card {{ currentIndex + 1 }} of {{ words.length }}</span>
        <div class="d-flex gap-3 small">
          <span class="text-success"><i class="bi bi-check-circle-fill"></i> {{ rightCount }}</span>
          <span class="text-danger"><i class="bi bi-x-circle-fill"></i> {{ wrongCount }}</span>
          <span class="text-secondary"><i class="bi bi-arrow-right-circle-fill"></i> {{ skipCount }}</span>
        </div>
      </div>

      <div class="progress mb-4" style="height: 6px;">
        <div class="progress-bar" [style.width.%]="(currentIndex / words.length) * 100"></div>
      </div>

      <!-- Card -->
      <div class="card-flip-container mb-4" (click)="state === 'sentence' && reveal()" [style.cursor]="state === 'sentence' ? 'pointer' : 'default'" [title]="state === 'sentence' ? 'Click to reveal the translation' : ''">
        <div class="card-inner" [class.flipped]="isFlipped" [class.no-transition]="skipTransition">

          <!-- Front: sentence -->
          <div class="card-face card-front rounded-4 d-flex flex-column justify-content-center align-items-center text-center bg-white shadow-sm" style="padding: 2rem">
            <p class="text-muted small mb-2">Translate this word</p>
            <h2 class="mb-0">{{ currentWord.sentence }}</h2>
          </div>

          <!-- Back: translation -->
          <div class="card-face card-back rounded-4 d-flex flex-column justify-content-center align-items-center text-center bg-light shadow-sm" style="padding: 2rem">
            <p class="text-muted small mb-2">Sentence</p>
            <h2 class="mb-3">{{ currentWord.sentence }}</h2>
            <hr class="w-100 my-0">
            <p class="text-muted small mb-2 mt-3">Translation</p>
            <h3 class="text-primary mb-0">{{ currentWord.translation }}</h3>
          </div>

        </div>
      </div>

      <!-- Hint (first card only) -->
      @if (state === 'sentence' && currentIndex === 0) {
      <p class="text-center text-muted small mb-3">
        <i class="bi bi-hand-index me-1"></i>Tap the card to see the translation
      </p>
      }

      <!-- Actions -->
      @if (state === 'sentence') {
      <div class="row g-2">
        <div class="col-12">
          <button class="btn btn-outline-secondary w-100 btn-lg" (click)="submit('SKIP')">
            <i class="bi bi-arrow-right me-1"></i>Skip
          </button>
        </div>
      </div>
      }

      @if (state === 'translation') {
      <div class="row g-2">
        <div class="col-6">
          <button class="btn btn-success w-100 btn-lg" (click)="submit('RIGHT')">
            <i class="bi bi-check-lg me-1"></i>Right
          </button>
        </div>
        <div class="col-6">
          <button class="btn btn-danger w-100 btn-lg" (click)="submit('WRONG')">
            <i class="bi bi-x-lg me-1"></i>Wrong
          </button>
        </div>
      </div>
      }

      @if (error) {
      <p class="text-danger text-center mt-3 small">{{ error }}</p>
      }

    </div>
  </div>
  }

  <!-- Session complete -->
  @if (state === 'complete') {
  <div class="row justify-content-center">
    <div class="col-md-6 text-center py-4">
      <i class="bi bi-trophy-fill fs-1 text-warning"></i>
      <h3 class="mt-3">Session complete!</h3>
      <p class="text-muted">You reviewed {{ words.length }} words.</p>

      <div class="row g-3 my-3">
        <div class="col-4">
          <div class="card border-0 bg-success bg-opacity-10 py-3">
            <div class="fs-2 fw-bold text-success">{{ rightCount }}</div>
            <div class="small text-muted">Right</div>
          </div>
        </div>
        <div class="col-4">
          <div class="card border-0 bg-danger bg-opacity-10 py-3">
            <div class="fs-2 fw-bold text-danger">{{ wrongCount }}</div>
            <div class="small text-muted">Wrong</div>
          </div>
        </div>
        <div class="col-4">
          <div class="card border-0 bg-secondary bg-opacity-10 py-3">
            <div class="fs-2 fw-bold text-secondary">{{ skipCount }}</div>
            <div class="small text-muted">Skipped</div>
          </div>
        </div>
      </div>

      <div class="d-flex gap-2 justify-content-center mt-4">
        <button class="btn btn-primary" (click)="restart()">
          <i class="bi bi-arrow-clockwise me-2"></i>Practice Again
        </button>
        <a routerLink="/word/list" class="btn btn-outline-secondary">Back to Words</a>
      </div>
    </div>
  </div>
  }

</div>
